import { EnhancementService, RenderService } from '@web-rendering/groundcontrol-core';
import gc from './index';
import { EqtBeaconService, EqtConfigurationSettings, EquativPayloadService } from '@web-rendering/groundcontrol-eqt';
// Direct import (not via ad-experience barrel) so Banner's side-effectful banner.scss
// — which @uses responsive.scss — doesn't get pulled into the native bundle.
import { Clickout } from '@web-rendering/groundcontrol-ad-unit/tag/models/ad-experiences/clickout/clickout.component';

gc({
  payloadService: new EquativPayloadService(),
  trackerService: new EqtBeaconService(),
  configurationService: new EqtConfigurationSettings(),
  renderService: new RenderService(Clickout),
  enhancementService: new EnhancementService(undefined)
});
